var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineRepeateMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AA298C36-7B4A-407C-BB9D-F402011813BB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video,-Audio,-Image",
    transform: "translate(-620.000000, -508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "repeate-music",
    transform: "translate(620.000000, 508.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.38000488,16.9599485 C2.01000488,15.5799485 1.25,13.7599436 1.25,11.8299437 C1.25,7.81994343 4.5,4.55992365 8.5,4.55992365 L14.5700073,4.57994318 L13.4799957,3.53990412 C13.1799957,3.24990413 13.1700067,2.77990662 13.4600067,2.4799066 C13.75,2.17990659 14.2200043,2.16994812 14.5200043,2.45994811 L16.9600067,4.79991388 C17.1800067,5.00991388 17.25,5.33992121 17.1399994,5.61992121 C17.0299994,5.89992121 16.75,6.08995295 16.4400024,6.08995295 L8.49000549,6.06993341 C5.32000542,6.06993341 2.74000549,8.65995336 2.74000549,11.8399534 C2.74000549,13.3699534 3.33999264,14.8198997 4.42999268,15.9098997 C4.71999267,16.1998997 4.71999267,16.6798973 4.42999268,16.9698973 C4.28999268,17.1098973 4.10000366,17.1799192 3.91000366,17.1799192 C3.72000366,17.1799192 3.53000489,17.1099485 3.38000488,16.9599485 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4798975,21.5399485 L7.0398951,19.1999826 C6.8198951,18.9899826 6.74990242,18.6599753 6.85990242,18.3799753 C6.96990242,18.0999753 7.24989939,17.9099436 7.55989939,17.9099436 L15.5098963,17.9299631 C18.6798964,17.9299631 21.2598963,15.3399441 21.2598963,12.1599441 C21.2598963,10.6299441 20.6599091,9.17999756 19.5699091,8.08999753 C19.2799091,7.79999754 19.2799091,7.31999999 19.5699091,7.03 C19.8599091,6.74000001 20.3399067,6.74000001 20.6299067,7.03 C21.9999067,8.41 22.7598963,10.2299441 22.7598963,12.1599441 C22.7598963,16.1699443 19.5098963,19.4299631 15.5098963,19.4299631 L9.43990421,19.4099436 L10.5299006,20.4499826 C10.8299006,20.7399826 10.8399048,21.2099802 10.5499048,21.5099802 C10.3899048,21.6699802 10.1999018,21.7499704 9.99990177,21.7499704 C9.80990177,21.7499704 9.62989751,21.6799485 9.4798975,21.5399485 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,12.75 C8.59,12.75 8.25,12.41 8.25,12 C8.25,11.59 8.59,11.25 9,11.25 L15,11.25 C15.41,11.25 15.75,11.59 15.75,12 C15.75,12.41 15.41,12.75 15,12.75 L9,12.75 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineRepeateMusic);
export default __webpack_public_path__ + "static/media/vuesax-outline-repeate-music.d40f9bfc52a03b3f7d0916b46cc5f706.svg";
export { ForwardRef as ReactComponent };